import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeUnderscore',
})
export class RemoveUnderscorePipe implements PipeTransform {
  transform(value?: any): any {
    if (value === undefined || typeof value !== 'string') {
      return;
    } else {
      const newString = value.replace(/[_-]/g, ' '); // Replace both underscores and hyphens with spaces

      const titleCasedString = newString
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');

      return titleCasedString;
    }
  }
}
